export enum AscFindTheWordsPuzzleBoardSize {
  SIX_BY_SIX = 6,
  EIGHT_BY_EIGHT = 8,
  TEN_BY_TEN = 10,
  TWELVE_BY_TWELVE = 12,
}

export interface AscFindTheWordsPuzzleCellType {
  id: number;
  wordIndices: number[];
  character: string;
  row: number;
  column: number;
}

export interface AscFindTheWordsPuzzleWord {
  id?: string;
  word: string;
  clue?: string;
  wordIndex: number;
  orientation: 'horizontal' | 'vertical';
  direction: 'forward' | 'reverse';
  beginningCellNumber: number;
  length?: number;
  color?: string;
}
export interface AscFindTheWordsPuzzleBoardProps {
  className?: string;
  mode?: 'create' | 'solve' | "completed";
  /**
   * Size of the puzzle board.
   * @property AscFindTheWordsPuzzleBoardSize
   * @default AscFindTheWordsPuzzleBoardSize.TEN_BY_TEN
   */
  size?: AscFindTheWordsPuzzleBoardSize;
  /**
   * present in create mode
   */
  words?: string[];
  /**
   * present in solve mode
   */
  generatedWords?: AscFindTheWordsPuzzleWord[];
  /**
   * present in completed mode
   */
  solvedWords?: (AscFindTheWordsPuzzleWord & { found: boolean })[];
  onChange?: (words: AscFindTheWordsPuzzleWord[]) => void;
  onError?: (error: string) => void;
  onGenerate?: (
    words: AscFindTheWordsPuzzleWord[],
    size: AscFindTheWordsPuzzleBoardSize
  ) => void;
  disabled?: boolean;
}

interface AscFindTheWordsPuzzleBasicProps {
  className?: string;
  mode?: 'solve' | 'create' | "completed";
  size?: AscFindTheWordsPuzzleBoardSize;
  onError?: (error: string) => void;
  disabled?: boolean;
}

interface AscFindTheWordsPuzzleCreateProps
  extends AscFindTheWordsPuzzleBasicProps {
  words: string[];
  generatedWords?: never;
  solvedWords?: never;
  mode: 'create';
  onGenerate?: (
    words: AscFindTheWordsPuzzleWord[],
    size: AscFindTheWordsPuzzleBoardSize
  ) => void;
  onSolve?: never;
}

interface AscFindTheWordsPuzzleSolveProps
  extends AscFindTheWordsPuzzleBasicProps {
  generatedWords: AscFindTheWordsPuzzleWord[];
  words?: never;
  solvedWords?: never;
  mode: 'solve';
  onGenerate?: never;
  onSolve?: (words: AscFindTheWordsPuzzleWord[]) => void;
}

interface AscFindTheWordsPuzzleCompletedProps
  extends AscFindTheWordsPuzzleBasicProps {
  words?: never;
  generatedWords?: AscFindTheWordsPuzzleWord[];
  solvedWords: (AscFindTheWordsPuzzleWord & { found: boolean })[];
  mode: 'completed';
  onGenerate?: never;
  onSolve?: never;
}

export type AscFindTheWordsPuzzleProps =
  | AscFindTheWordsPuzzleCreateProps
  | AscFindTheWordsPuzzleSolveProps
  | AscFindTheWordsPuzzleCompletedProps;
